/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DiffViewer from 'shared/ui/components/dev-tools/document-editor/DiffViewer.vue';
import DocumentPanel from 'shared/ui/components/dev-tools/document-editor/DocumentPanel.vue';
import DocumentTab from 'shared/ui/components/dev-tools/document-editor/DocumentTab.vue';
import InputAutocomplete from 'shared/ui/components/form-components/InputAutocomplete.vue';

// Constants
const IDS_STORAGE_KEY = 'doc_editor_ids';
const LAST_FOCUS_KEY = 'doc_editor_last_focus';

const __vue_script__ = {
    name: 'DocumentEditor',

    components: { DiffViewer, DocumentPanel, DocumentTab, InputAutocomplete },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const event = this.params.event;
        const eid = event.id || event._id;
        return {
            currentTab: null,
            docId: '',
            event,
            eid,
            previousTerm: '',
            storeKey: `${IDS_STORAGE_KEY}:${eid}`,
            lastFocusKey: `${LAST_FOCUS_KEY}:${eid}`,
            suggestions: [],
            panes: []
        };
    },

    watch: {
        docId(value) {
            if (value?.length) {
                this.reset();
                this.addPane(value, 'doc');
            }
        },

        panes: {
            deep: true,
            handler(value) {
                const ids = value.map(p => p.data?._id || p.id).filter(i => !i.startsWith('TEMP:'));
                this.$services.storage.set(this.storeKey, ids);

                if (value.length === 0) {
                    this.newDocument();
                }
            }
        },

        currentTab(value) {
            if (!value.startsWith('TEMP:')) {
                this.$services.storage.set(this.lastFocusKey, value);
            }
        }
    },

    created() {
        this.newDocument();

        const store = this.$services.storage.get(this.storeKey) || [];
        for (const id of store) {
            if (id.startsWith('DIFF:')) {
                const [, docId, revA, revB] = id.split(':');
                this.openComparision(docId, revA, revB);
            } else {
                this.addPane(id, 'doc');
            }
        }

        const docId = this.getDocumentIdFromParams();
        if (docId) {
            this.addPane(docId, 'doc');
        } else {
            const lastFocus = this.$services.storage.get(this.lastFocusKey);
            if (lastFocus) {
                this.focusPane(lastFocus);
            }
        }
    },

    methods: {
        getDocumentIdFromParams() {
            if (this.$route) {
                return this.$route.params.docId;
            } else if (this.$router && this.$router.getSearchParams) {
                const params = this.$router.getSearchParams();
                return params.document;
            }
        },

        addPane(id, type, props = {}) {
            if (!id?.length || this.focusPane(id, props)) {
                return;
            }

            this.closePlaceholders();

            const pane = { id, type, props };
            if (type === 'doc') {
                Object.assign(pane.props, {
                    event: this.event,
                    documentId: id.startsWith('TEMP:') ? null : id
                });

                pane.component = DocumentPanel;
                pane.on = {
                    change: doc => this.updatePane(id, doc),
                    changed: (doc, changed) => this.updatePane(id, doc, { changed }),
                    compare: this.openComparision,
                    error: () => this.removePane(id),
                    ready: doc => this.updatePane(id, doc),
                    select: (item, path) => this.addPane(item, 'doc', { scrollTo: path, mode: item === 'metadata' ? 'tree' : 'text' })
                };
            }

            if (type === 'diff') {
                pane.component = DiffViewer;
            }

            this.panes.push(pane);
            this.currentTab = id;
        },

        focusPane(id, props = {}) {
            if (!id?.length) {
                return false;
            }

            const pane = this.panes.find(p => p.id === id);
            if (pane) {
                console.debug('[DocumentEditor] Opening pane with id', id);
                for (const [prop, value] of Object.entries(props)) {
                    this.$set(pane.props, prop, value);
                }
                this.currentTab = id;
                return true;
            }

            console.debug('[DocumentEditor] Could not find any tab with id', id);
            return false;
        },

        updatePane(id, data, flags) {
            const pane = this.panes.find(p => p.id === id);
            if (!pane) {
                console.warn('[DocumentEditor] Cannot update panel: panel not found');
                return;
            }

            this.$set(pane, 'data', data);

            if (typeof flags !== 'undefined') {
                for (const [flag, value] of Object.entries(flags)) {
                    this.$set(pane, flag, value);
                }
            }
        },

        removePane(id) {
            let index = this.panes.findIndex(d => d.id === id);
            if (index === -1) {
                index = 0;
            }

            this.panes = this.panes.filter(p => p.id !== id);

            if (id === this.currentTab) {
                const pane = this.panes[index <= 0 ? 0 : index - 1];
                if (pane) {
                    this.currentTab = pane.id;
                } else {
                    this.currentTab = null;
                }
            }
        },

        reset() {
            this.docId = '';
            this.suggestions = [];
            this.previousTerm = '';
        },

        async loadSuggestions(query) {
            try {
                if (query?.length >= 3 && query !== this.previousTerm) {
                    const suggestions = await this.$services.appScripts.callAppScript(this.event.id, 'dev-tools/autocomplete', { query });
                    this.suggestions = suggestions;
                }
            } catch (error) {
                console.error('[DocumentEditor] Could not load suggestions', error.message);
            } finally {
                this.previousTerm = query;
            }
        },

        openComparision(docId, revA, revB) {
            console.info('[DocumentEditor] Start comparison', docId, revA, revB);
            const id = `DIFF:${docId}:${revA}:${revB}`;

            this.addPane(id, 'diff', {
                eventId: this.eid,
                diff: {
                    id: docId,
                    source: revA,
                    target: revB
                }
            });
        },

        newDocument() {
            const id = `TEMP:${Date.now()}`;
            this.addPane(id, 'doc');
        },

        closePlaceholders() {
            const placeholders = this.panes.filter(p => p.id.startsWith('TEMP:') && !p.changed);
            for (const id of placeholders.map(p => p.id)) {
                this.removePane(id);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "document-editor" }, [
    _c("div", { staticClass: "heading" }, [
      _c(
        "ul",
        { staticClass: "tabs" },
        [
          _c(
            "li",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$t("dev_tools.document_editor.add_new_doc"),
                  expression: "$t('dev_tools.document_editor.add_new_doc')",
                },
              ],
              staticClass: "new-doc",
            },
            [
              _c(
                "a",
                { staticClass: "has-action", on: { click: _vm.newDocument } },
                [_c("i", { staticClass: "ic-file-plus" })]
              ),
            ]
          ),
          _vm._l(_vm.panes, function (tab) {
            return _c(
              "li",
              { key: tab.id, class: { active: tab.id === _vm.currentTab } },
              [
                _c("document-tab", {
                  attrs: { tab: tab, event: _vm.event },
                  on: {
                    click: function ($event) {
                      _vm.currentTab = tab.id
                    },
                    close: function ($event) {
                      return _vm.removePane(tab.id)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "search-bar" },
        [
          _c("input-autocomplete", {
            attrs: {
              "clean-after": true,
              placeholder: _vm.$t("general.search"),
              suggestions: _vm.suggestions,
              "show-perfect-match": true,
              "emit-on-blur": false,
              limit: 8,
              name: "docId",
              "track-by": "id",
              "alt-track-by": "fp_ext_id",
            },
            on: { change: _vm.loadSuggestions },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function (ref) {
                  var item = ref.item
                  var selectItem = ref.selectItem
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "suggestion has-action",
                        on: {
                          click: function ($event) {
                            return selectItem(item)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "id" }, [
                          _vm._v(_vm._s(item.id)),
                        ]),
                        item.fp_ext_id
                          ? _c("span", { staticClass: "ext" }, [
                              _vm._v(_vm._s(item.fp_ext_id)),
                            ])
                          : _vm._e(),
                        item.fp_type
                          ? _c("span", { staticClass: "type" }, [
                              _vm._v(_vm._s(item.fp_type)),
                            ])
                          : _vm._e(),
                        item.fp_type && item.title
                          ? _c("span", { staticClass: "sep" }, [_vm._v(" •")])
                          : _vm._e(),
                        item.title
                          ? _c("span", { staticClass: "title" }, [
                              _vm._v(" " + _vm._s(item.title)),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.docId,
              callback: function ($$v) {
                _vm.docId = $$v
              },
              expression: "docId",
            },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "panes" },
      _vm._l(_vm.panes, function (pane) {
        return _c(
          pane.component,
          _vm._g(
            _vm._b(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: pane.id === _vm.currentTab,
                    expression: "pane.id === currentTab",
                  },
                ],
                key: pane.id,
                tag: "component",
              },
              "component",
              pane.props,
              false
            ),
            pane.on
          )
        )
      }),
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/dev-tools/DocumentEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__